import {Component, OnInit, inject} from '@angular/core';
import {DataService} from "../../../services/data.service";
import {RouterLink} from '@angular/router';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {FormsModule} from '@angular/forms';
import {NgIf, NgFor, DatePipe} from '@angular/common';
import {YesNoPipe} from '../../../pipes/yes-no.pipe';
import {TeamRolePipe} from '../../../pipes/team-role.pipe';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrl: './user-list.component.scss',
    imports: [RouterLink, PaginationModule, FormsModule, NgIf, NgFor, DatePipe, YesNoPipe, TeamRolePipe]
})
export class UserListComponent implements OnInit {

    private dataService = inject(DataService);

    paginConfig: any;
    entries: any[];
    totalEntries = 0;
    predicate = 'name';
    search: any;
    reverse = false;
    showInactive = false;

    ngOnInit(): void {
        this.search = {
            text: ''
        };
        this.paginConfig = {
            itemsPerPage: 25,
            page: 1
        };
        this.listEntries(this.paginConfig);
    }

    setOrder(order): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('User/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            filter: this.search.text,
            showInactive: this.showInactive,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.users;
            this.entries.forEach(entry => {
                entry.active = entry.active === '1';
                entry.roles = entry.roles ? entry.roles.split(',') : [];
            });
        });
    }

}
